import React from 'react';
import { User } from '../../../../../services/eventService';

interface VotesModalProps {
  show: boolean;
  onClose: () => void;
  votes: any[];
  users: User[];
  handleDownloadVotes: () => Promise<void>;
}

const VotesModal: React.FC<VotesModalProps> = ({
  show,
  onClose,
  votes,
  users,
  handleDownloadVotes
}) => {
  if (!show) return null;

  // Helper function to find user by ID
  const findUserById = (userId: string) => {
    const userIdStr = String(userId);
    return users.find(u => u.User_ID === userIdStr) ?? null;
  };

  // Helper function to display user name
  const getDisplayName = (user: User | null, userId: string) => {
    if (user?.firstname && user?.lastname) {
      return `${user.firstname} ${user.lastname}`;
    }
    if (user?.firstname || user?.lastname) {
      return user?.firstname || user?.lastname || `User (ID: ${userId})`;
    }
    // If user not found in the users list, show ID
    return `User (ID: ${userId})`;
  };

  return (
    <div className="modal show d-block" tabIndex={-1}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Votes for Event</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <ul className="list-group">
              {votes && votes.length > 0 ? (
                votes.map((vote, index) => {
                  // Find voter and voted user
                  const voter = findUserById(vote.selector_user_id);
                  const voted = findUserById(vote.selected_user_id);
                  
                  return (
                    <li key={index} className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <strong>{getDisplayName(voter, vote.selector_user_id)}</strong>
                          <span className="mx-2">voted for</span>
                          <strong>{getDisplayName(voted, vote.selected_user_id)}</strong>
                          {vote.rank && <span className="ms-2 badge bg-primary">Rank {vote.rank}</span>}
                        </div>
                        <small className="text-muted">
                          Vote ID: {vote.Vote_ID}
                        </small>
                      </div>
                    </li>
                  );
                })
              ) : (
                <li className="list-group-item text-center py-3 text-muted">No votes recorded yet</li>
              )}
            </ul>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary-outline" onClick={onClose}>
              Close
            </button>
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleDownloadVotes}
            >
              <i className="bi bi-file-earmark-excel"></i> Download as Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VotesModal;
